/**
 * Suhaani Weaves — recently viewed products.
 *
 * Only product handles are stored, in this browser's localStorage. Nothing is
 * sent anywhere, no identifier is created, and the list never leaves the
 * device. Each card is re-rendered from live Shopify data so a price change or
 * an unpublished product is reflected immediately rather than cached.
 */
(function () {
  'use strict';

  const KEY = 'Suhaani Weaves:recently-viewed';
  const MAX_STORED = 12;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /* localStorage throws in private mode and with site data blocked. */
  function read() {
    try {
      const raw = window.localStorage.getItem(KEY);
      const list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list.filter((h) => typeof h === 'string' && h) : [];
    } catch (error) {
      return [];
    }
  }

  function write(list) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX_STORED)));
    } catch (error) {
      /* Nothing here is essential; a blocked store just means no history. */
    }
  }

  /** Records the product currently being viewed, most recent first. */
  function record() {
    const el = document.querySelector('[data-product-handle-current]');
    const handle = el && el.getAttribute('data-product-handle-current');
    if (!handle) return;
    const list = read().filter((h) => h !== handle);
    list.unshift(handle);
    write(list);
  }

  async function renderInto(container) {
    const limit = Number(container.getAttribute('data-limit') || 4);
    const exclude = container.getAttribute('data-exclude') || '';
    const grid = container.querySelector('[data-recently-viewed-grid]');
    if (!grid) return;

    const handles = read().filter((h) => h !== exclude).slice(0, limit);
    if (handles.length === 0) {
      container.hidden = true;
      return;
    }

    const missing = [];
    const cards = await Promise.all(
      handles.map(async (handle) => {
        try {
          const response = await fetch(
            root() + 'products/' + encodeURIComponent(handle) + '?section_id=product-card-fragment'
          );
          if (!response.ok) {
            /* Deleted or unpublished — drop it rather than show a gap. */
            missing.push(handle);
            return null;
          }
          const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
          const card = parsed.querySelector('[data-product-card]');
          return card ? card.outerHTML : null;
        } catch (error) {
          return null; /* a network blip should not delete the entry */
        }
      })
    );

    if (missing.length) write(read().filter((h) => missing.indexOf(h) === -1));

    const html = cards.filter(Boolean);
    if (html.length === 0) {
      container.hidden = true;
      return;
    }

    grid.innerHTML = html.map((c) => '<li class="product-grid__item">' + c + '</li>').join('');
    container.hidden = false;

    /* Wishlist buttons inside freshly inserted cards need their state applied. */
    if (window.Urbanshop && window.Urbanshop.wishlist && window.Urbanshop.wishlistSync) {
      window.Urbanshop.wishlistSync();
    }
  }

  function init() {
    record();
    document.querySelectorAll('[data-recently-viewed]').forEach(renderInto);
  }

  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-recently-viewed-clear]')) return;
    write([]);
    document.querySelectorAll('[data-recently-viewed]').forEach((c) => {
      c.hidden = true;
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
